import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { hash } from "../../../utils/hashFunction";
import { ITenant, postLocalType } from "../types";

export const getLocal = async (idLocal: number, tenant: ITenant) =>
  await axiosInstanceMain
    .post(`/${tenant.path}/locales/${idLocal}?vendedor`)
    .then((result) => result);
export const postLocal = async (data: postLocalType, tenant: ITenant) =>
  await axiosInstanceMain.post(`/${tenant.path}/locales`, data);
export const updateLocal = async (
  idLocal: number | string,
  data: postLocalType,
  tenant: ITenant
) =>
  await axiosInstanceMain.put(`/${tenant.path}/locales/${idLocal}`, {
    ...data,
    idLocal,
  });

export const uploadFoto = async (
  idLocal: number,
  imagenBase64: any,
  tenant: ITenant
) => {
  const clave = await hash(idLocal + "lugares2017");
  return await axiosInstanceMain.post(
    `/${tenant.path}/locales/${idLocal}/logo`,
    {
      imagenBase64,
      clave,
      idLocal,
    }
  );
};
